import React from 'react';

import FormSection from 'containers/FormSectionContainer';
import FieldSet from 'containers/FieldSetContainer';
import FormField from 'containers/FormField';

import FormProvider from 'routes/Documents/containers/FormProvider';
import { UploadAvatarDialog } from './Avatar/UploadAvatarDialog';
import ContactInfoList from './ContactInfoList';
import { withSession } from 'containers/SessionProvider';

const ProfileForm = ({ session, ...props }) => {
  let firstNames = '';
  let lastNames = '';
  if (session) {
    firstNames = session.firstName || '';
    lastNames = session.lastName || '';
  }
  return (
    <FormProvider {...props}>
      <FormSection localeId="profile.nameData">
        <FieldSet localeId="profile.profilePicture">
          <UploadAvatarDialog />
        </FieldSet>
        <FieldSet localeId="profile.lastNames">
          <div style={{ fontWeight: 600, padding: '1.2rem 0 0' }}>{firstNames}</div>
        </FieldSet>
        <FieldSet localeId="profile.firstNames">
          <div style={{ fontWeight: 600, padding: '1.2rem 0 0' }}>{lastNames}</div>
        </FieldSet>
      </FormSection>
      <FormSection localeId="profile.phoneAndEmail">
        <FieldSet localeId="profile.phoneNumbers">
          <FormField name="contactInfo" component={ContactInfoList} type="sms" />
        </FieldSet>
        <FieldSet localeId="profile.emailAddresses">
          <FormField name="contactInfo" component={ContactInfoList} type="email" />
        </FieldSet>
      </FormSection>
    </FormProvider>
  );
};

export default withSession(ProfileForm);
